import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

export function WorkspaceSwitcher() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/workspaces").then((r) => setData(r.data)); }, []);
  if (!data || data.workspaces.length < 2) return null;
  const change = async (v) => {
    await api.post("/workspaces/switch", { workspace_id: v });
    window.location.href = "/dashboard";
  };
  return (
    <div className="mb-1">
      <div className="font-mono text-[10px] uppercase tracking-widest text-slate-400 mb-1 px-1">Workspace</div>
      <Select value={data.active} onValueChange={change}>
        <SelectTrigger className="h-9 text-sm" data-testid="workspace-switcher"><SelectValue /></SelectTrigger>
        <SelectContent>
          {data.workspaces.map((w) => <SelectItem key={w.workspace_id} value={w.workspace_id}><span className="truncate">{w.name}</span>{w.role === "member" && <span className="ml-1.5 text-[10px] font-mono uppercase text-slate-400">member</span>}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
